/**
 * HermanRX Product Checkout Handler
 * Manages dropdown selections and redirects to MD Integrations checkout
 */
(function() {
  'use strict';

  // When a dropdown changes, update price display and checkout link
  document.addEventListener('change', function(e) {
    if (!e.target.classList.contains('pp-product-selector__select')) return;

    var select = e.target;
    var card = select.closest('.pp-pricing-card') || select.closest('.pp-product-selector').parentElement;
    var selectedOption = select.options[select.selectedIndex];

    // Update price display
    var priceEl = card.querySelector('.pp-pricing-card__dynamic-price');
    if (priceEl && selectedOption.dataset.price) {
      priceEl.classList.add('pp-price-updating');
      setTimeout(function() {
        priceEl.innerHTML = selectedOption.dataset.price + (selectedOption.dataset.period ? '<span>' + selectedOption.dataset.period + '</span>' : '');
        priceEl.classList.remove('pp-price-updating');
      }, 150);
    }

    // Update checkout button href
    var checkoutBtn = card.querySelector('.pp-checkout-btn');
    if (checkoutBtn && selectedOption.dataset.checkout) {
      checkoutBtn.href = selectedOption.dataset.checkout;
    }
  });

  // Checkout button click handler - open in new tab
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.pp-checkout-btn');
    if (!btn) return;

    var href = btn.getAttribute('href');
    if (!href || href === '#') {
      e.preventDefault();
      alert('Please select an option first.');
      return;
    }
  });
})();
